import React from 'react';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Tree from '../../../tree/Index';

import randomstring from 'uuid/v4';

const flatNodes = (node) => {
    let result = [node];
    if (node.children) {
        node.children.forEach((c) => (result = result.concat(flatNodes(c))));
    }
    return result;
};

const reviewComplete = (node, arr) => {
    const toReview = flatNodes(node);
    let result = true;
    if (toReview && toReview.length > 0) {
        const index = arr.map((i) => i.id.toString());
        toReview.forEach((r) => {
            result = result && index.indexOf(r.id.toString()) >= 0;
        });
    }
    return result;
};

class PresentationDialog extends React.Component {
    state = {
        value: undefined,
        open: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value || props.info !== state.info) {
            state.value = props.value;
            state.info = props.info;
            return state;
        }

        return null;
    }

    handleChange = (event) => {
        const { value } = this.state;
        value[event.target.name] = event.target.value;
        this.setState({ value: value });
    };

    handleClose = (value) => (event) => {
        this.props.onClose(value);
    };

    sortedTree = (tree) => {
        const hijos = [...tree.children]
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((c) => this.sortedTree(c));
        tree.children = hijos;
        return tree;
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx('collapse padding_top_12', collapsed ? 'caret-right' : 'caret-down')}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };

    renderNode = (node) => {
        return (
            <span
                className={cx(
                    'barlow_regular_message margin_left_12 ',
                    {
                        c_bluish:
                            node &&
                            this.state.value.locales &&
                            this.state.value.locales.some(
                                (n) => parseInt(n.id, 10) === parseInt(node.id, 10),
                            ),
                    },
                    {
                        c_lipstick: !this.isNodeEnabled(node),
                    },
                )}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.onClickNode.bind(null, node)}
            >
                {node.name}
            </span>
        );
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx('collapse', collapsed ? 'caret-right' : 'caret-down')}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };

    isNodeEnabled = (node) => {
        const { info } = this.props;
        const enable =
            node &&
            node.id &&
            info &&
            info.security &&
            info.security.localPermits &&
            info.security.localPermits[node.id.toString()]
                ? info.security.localPermits[node.id.toString()].some(
                      (r) => r === '20' || r === '64',
                  )
                : info && info.security && info.security.globalPermits
                ? info.security.globalPermits.some((r) => r === '20' || r === '64')
                : undefined;
        return enable;
    };

    onClickNode = (node) => {
        if (this.isNodeEnabled(node)) {
            let nodes = flatNodes(node);
            if (
                node &&
                this.state.value.locales &&
                this.state.value.locales.map((c) => c.id.toString()).indexOf(node.id.toString()) >=
                    0
            ) {
                const toRemove = nodes;
                if (toRemove && toRemove.length > 0) {
                    nodes = this.state.value.locales;
                    toRemove.forEach((r) => {
                        const index = nodes.map((i) => i.id.toString()).indexOf(r.id.toString());
                        if (index >= 0) {
                            nodes.splice(index, 1);
                        }
                    });
                }
            } else {
                const aux = this.state.value.locales;
                nodes.forEach((r) => {
                    const index = aux.map((i) => i.id.toString()).indexOf(r.id.toString());
                    if (index < 0) {
                        aux.push(r);
                    }
                });
                nodes = aux;
            }

            if (nodes && nodes.length > 0) {
                const nodesToReview = [...nodes].sort((a, b) => (a.path > b.path ? -1 : 1));
                nodesToReview.forEach((n) => {
                    if (!reviewComplete(n, nodes)) {
                        const toRemoveIndex = nodes
                            .map((i) => i.id.toString())
                            .indexOf(n.id.toString());
                        nodes.splice(toRemoveIndex, 1);
                    }
                });
            }
            const { value } = this.state;
            value.locales = nodes;
            this.setState({
                value: value,
            });
        }
    };

    render() {
        const { value } = this.state;
        const { intl, references } = this.props;
        const reference = value.idReferencia
            ? references.find((f) => f.id.toString() === value.idReferencia.toString())
            : undefined;
        const presentation = reference ? reference.presentaciones : [];
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate upper'}>
                            <InputLabel htmlFor="age-native-simple" className="upper">
                                {intl.formatMessage({ id: 'manage_reference_menu' })}
                            </InputLabel>
                            <Select
                                native
                                value={value.idReferencia}
                                onChange={this.handleChange}
                                inputProps={{ name: 'idReferencia', id: 'idReferencia' }}
                                className="upper"
                            >
                                <option key={randomstring()} value={undefined} />
                                {references &&
                                    references
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.id}
                                                >
                                                    {cat.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate upper'}>
                            <InputLabel htmlFor="age-native-simple" className="upper">
                                {intl.formatMessage({ id: 'form_field_name_presentations' })}
                            </InputLabel>
                            <Select
                                native
                                value={value.idPresentacion}
                                onChange={this.handleChange}
                                inputProps={{ name: 'idPresentacion', id: 'idPresentacion' }}
                                className="upper"
                            >
                                <option key={randomstring()} value={undefined} />
                                {presentation &&
                                    presentation
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.id}
                                                >
                                                    {cat.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <Tree
                            paddingLeft={40}
                            tree={this.sortedTree(this.props.info.security.hierarchies)}
                            orderBy={'name'}
                            renderNode={this.renderNode} // renderNode(node) return react element
                            renderCollapse={this.renderCollapse}
                            isNodeCollapsed={this.isNodeCollapsed}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        disabled={
                            !value ||
                            !value.idReferencia ||
                            !value.idPresentacion ||
                            !value.locales ||
                            value.locales.length === 0
                        }
                        onClick={this.handleClose(value)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PresentationDialog;



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/DialogReferences.js